export class Partnership {
  fullName = "";
  title = "";
  email = "";
  phone = "";
  college = "";
  city = "";
  state = "";
  nrOfStudents = 0;
  infoGeneral = false;
  infoPrint = false;
  infoDigital = false;
  comments = "";
}
